export const SMList = [
      {
        id: 1,
        name: 'Aryan Lohia',
        designation: 'Tech Head',
        fb: 'https://www.facebook.com/aryan.lohia.52687',
        instagram: '',
        linkedin:'https://www.linkedin.com/in/aryan-lohia-a46b52213/',
        pfp: '/assets/images/Aryan.jpeg',
      },
      {
        id: 2,
        name: 'Himanshu Jangir',
        designation: 'Tech Head',
        fb: 'https://www.facebook.com/share/1EcR1SabuD/?mibextid=wwXIfr',
        instagram: '',
        linkedin:'https://www.linkedin.com/in/himanshu-jangir-868271290/',
        pfp: '/assets/images/himanshu.jpg',
      },
      {
        id: 3,
        name: 'Dnyaneshwari Ghare',
        designation: 'Executive Head',
        fb: 'https://www.facebook.com/share/1AsSWpgqdv/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/dnyaneshwari-ghare-9a274928b/',
        pfp: '/assets/images/dnyaneshwari.jpg',
      },
      {
        id: 4,
        name: 'Tanush Agarwal',
        designation: 'Executive Head',
        fb: 'https://www.facebook.com/people/Tanush-Agarwal/pfbid02eLEAKCznrfH2HXBbbBpPhM9XV6Arz3QNFaASr59NBndnWELTpAchXCYne3eXPQXRl/',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/tanush-agarwal-83893727a/',
        pfp: '/assets/images/Tanush.jpg',
      },
      
      {
        id: 5,
        name: 'Bhukya Shashi Kumar',
        designation: 'Design Head',
        fb: 'https://www.facebook.com/share/19FMr9AS2R/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/shashi-kumar-bhukya-0882b8290/',
        pfp: '/assets/images/Shashi.jpg',
      },
      {
        id: 6,
        name: 'Katyayani Khola',
        designation: 'PR/Lit Head',
        fb: 'https://www.facebook.com/share/19J2tkhN3h/?mibextid=wwXIfr',
        instagram: '',
        linkedin:'https://www.linkedin.com/in/katyayani-khola-00aa35293/',
        pfp: '/assets/images/katyayani.jpeg',
      },
      
      {
        id: 7,
        name: 'Bhavy Vaishnav',
        designation: 'Core Head',
        fb: 'https://www.facebook.com/share/1G88Nck6Ey/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/bhavyvaishnav-kgpian/',
        pfp: '/assets/images/bhavy.jpg',
      },
      {
        id: 8,
        name: 'Gaurang Mehra',
        designation: 'Core Head',
        fb: 'https://www.facebook.com/people/Gaurang-Mehra/pfbid032ET79fxaZY6UDA1abdPX7XsWeCKMHSR713dCkHEhegt7HeGyvde6YekMkCJSuW1yl/',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/gaurang-mehra-177700196/',
        pfp: '/assets/images/gaurang.jpeg',
      },
      {
        id: 9,
        name: 'Shourya Godha',
        designation: 'Videography Head',
        fb: 'https://www.facebook.com/share/1G51cu6Ki8/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/shourya-godha-73050b28a/',
        pfp: '/assets/images/shourya1.jpeg',
      },
      
  ];